module.exports = __webpack_public_path__ + "img/artists-carrousel-6.d338b166.png";